const letterRootState = {
    abstract: true,
    url: '/letters',
    template: '<ui-view></ui-view>'
};

const letterComposeState = {
    url: '',
    template: require('./controllers/letters/compose/letter-compose.html'),
    controller: require('./controllers/letters/compose/composeLetterCtrl'),
    controllerAs: 'composeView'
};

const scannedLetterUpload = {
    url: '/scannedLetterUpload',
    template: require('./controllers/letters/upload/upload.html'),
    controller: require('./controllers/letters/upload/uploadCtrl')
};

export default function (app) {
    app.config(($stateProvider, userRolesObject) => {
        letterRootState.data = {
            roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead, userRolesObject.rrd]
        };

        scannedLetterUpload.data = {
            roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead]
        };

        $stateProvider
            .state('letters', letterRootState)
            .state('letters.list', letterComposeState)
            .state('uploadScannedLetter', scannedLetterUpload);
    });
}



// WEBPACK FOOTER //
// ./Client/app/letter-communication/routes.js